<template>
  <div class="apply-step apply-step--terminal">
    <div class="apply-step__icon">⏳</div>
    <h2>Ya tienes una aplicación previa</h2>
    <p v-if="retryAfter">
      Puedes volver a aplicar desde el <strong>{{ formatDate(retryAfter) }}</strong>.
    </p>
    <p v-else>
      Aún no han pasado 6 meses desde tu última aplicación. Vuelve pronto.
    </p>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'ResultCooldown',
  computed: {
    ...mapState('apply', ['fields']),
    retryAfter() {
      return this.fields.resultado_exam && this.fields.resultado_exam.retryAfter
    },
  },
  mounted() { this.clearAll() },
  methods: {
    ...mapActions('apply', ['clearAll']),
    formatDate(iso) {
      try {
        return new Date(iso).toLocaleDateString('es-CO', { year: 'numeric', month: 'long', day: 'numeric' })
      } catch (err) { return iso }
    },
  },
}
</script>

<style src="../apply-step.css" scoped></style>
<style scoped>
.apply-step--terminal { text-align: center; padding: 2rem 1rem; }
.apply-step__icon { font-size: 4rem; margin-bottom: 1rem; }
</style>
